import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, viewChild } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from '../../../services/common.service';
import { MatIconModule } from '@angular/material/icon';
import { NgClass, NgOptimizedImage, NgStyle } from '@angular/common';
import { CustomFlexLayoutModule } from '../../../flex-layout/custom-flex-layout.module';
import { NgOptimizedImageComponent } from '../ng-optimized-image/ng-optimized-image.component';
import { Search3Component } from '../../components/search3/search3.component';
import { EditorTextComponent } from '../editor-text/editor-text.component';
import { FormPopupComponent } from '../form-popup/form-popup.component';
import { ContactService } from '../../../services/contact.service';
import { Overlay } from '@angular/cdk/overlay';
@Component({
  selector: 'calsoft-video-banner-search',
  imports: [MatIconModule, NgStyle, NgClass, CustomFlexLayoutModule, EditorTextComponent, NgOptimizedImageComponent, Search3Component],
  templateUrl: './video-banner-search.component.html',
  styleUrl: './video-banner-search.component.scss'
})
export class VideoBannerSearchComponent {

  private wrapper!: HTMLElement;
  private content!: HTMLElement;
  private isHovered = false;
  private attractionRadius = 200; // The distance at which attraction starts
  readonly videoPlayer = viewChild<ElementRef>('videoPlayer');

  public serverPath = environment.commonImageApi + '/commonSlider/';
  public serverPath1 = environment.commonImageApi + '/home/';
  @Input() item: any;

  @Input() img: any;

  @Input() data: any;

  public youtubeUrl = environment.youtubeUrl;

  image: any;

  constructor(private sanitizer: DomSanitizer,
    private commonService: CommonService,
    public dialog: MatDialog,
    private contactService: ContactService,
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
    private overlay: Overlay
  ) { }


  ngOnInit() {

    this.image = this.serverPath + this.img[0].img;

    console.log(this.image);

  }


  searchPage() {

  }

  readonly searchBox = viewChild.required<ElementRef>('searchBox');
  readonly button = viewChild.required<ElementRef>('button');

  isDragging = false;
  offsetX = 0;
  offsetY = 0;
  containerRect!: DOMRect;
  buttonRect!: DOMRect;

  ngAfterViewInit(): void {
    this.wrapper = this.el.nativeElement.querySelector('.magnetic-wrapper-container');
    this.content = this.el.nativeElement.querySelector('.magnetic-content-container');

    if (this.wrapper) {
      this.wrapper.addEventListener('mouseleave', () => {
        this.isHovered = false;
        this.resetEffect();
      });
    }
  }



  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    if (!this.wrapper || !this.content) return;

    const { clientX, clientY } = event;
    const { left, top, width, height } = this.wrapper.getBoundingClientRect();

    const centerX = left + width / 2;
    const centerY = top + height / 2;

    // Calculate distance between cursor and the center of the circle
    const deltaX = clientX - centerX;
    const deltaY = clientY - centerY;
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

    if (distance < this.attractionRadius) { // If within attraction range
      this.isHovered = true;

      const maxTranslate = 30; // Maximum movement of the element
      const translateX = (deltaX / distance) * maxTranslate;
      const translateY = (deltaY / distance) * maxTranslate;

      // Reduce the size slightly as it moves
      const scale = 1 - (distance / this.attractionRadius) * 0.2; // Shrinks by 20% at max attraction

      this.content.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
    } else {
      this.isHovered = false;
      this.resetEffect();
    }
  }
  private resetEffect(): void {
    this.content.style.transform = 'translate(0px, 0px) scale(1)'; // Reset to original state
  }


  @HostListener('mouseleave')
  onMouseLeave(): void {
    if (this.content) {
      this.content.style.transform = 'translate(0px, 0px)';
    }
  }
  popupType = 2;
  dynamicFormPopup(formGroupId: any) {
    this.contactService.getDynmaicForm(formGroupId).subscribe((data) => {
      const regConfig = data;

      const dialogData: any = {
        formId: formGroupId,
        type: this.popupType,
        regConfigdata: regConfig
      };

      const dialogConfig = {
        data: dialogData,
        enterAnimationDuration: '400ms',
        exitAnimationDuration: '100ms',
        position: { top: '0', right: '0' },
        panelClass: 'custom-dialog',
        hasBackdrop: false,
        scrollStrategy: this.overlay.scrollStrategies.noop(),
        disableClose: true
      };

      let dialogRef;
      console.log("the form navigatio is", this.item.customField11);

      localStorage.setItem("formNavigation", this.item.customField11)

      if (window.innerWidth > 768) {
        dialogRef = this.dialog.open(FormPopupComponent, {
          width: '400px',
          height: '100vh',
          ...dialogConfig
        });
      } else {
        dialogRef = this.dialog.open(FormPopupComponent, {
          minWidth: '100vw',
          height: '100vh',
          ...dialogConfig
        });
      }

      dialogRef.afterOpened().subscribe(() => {
        this.cdr.detectChanges();
      });

      dialogRef.afterClosed().subscribe(result => {
        // Handle close if needed
      });
    });
  }



  imageNavigation(id: any) {


    if (id > 0) {
      this.commonService.goToCategory(1, parseInt(id));
    }

  }

  link(url: any) {

    this.commonService.goToLink(url)

  }

  scroll(id: any) {

    this.commonService.scrollDown(id)

  }


}

